import React, { useEffect, useState } from "react";
import "../Assests/GitActivityCard.css";
import { getLatestGitActivity } from "../Db_Connections/gitActivityApi";

function GitActivityCard() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGitActivity();
  }, []);

  const fetchGitActivity = async () => {
    try {
      const { data, error } = await getLatestGitActivity();

      console.log("Supabase data:", data);
      console.log("Supabase error:", error);

      if (error) {
        console.error("Error fetching data:", error.message);
        setActivities([]);
        return;
      }

      if (!data || data.length === 0) {
        console.log("No rows found in table");
        setActivities([]);
        return;
      }

      // ✅ Last 2 active dates nikaalna
      const uniqueDates = [];
      const filteredActivities = [];

      for (const item of data) {
        const dateKey = new Date(item.timestamp).toISOString().split("T")[0];

        if (!uniqueDates.includes(dateKey)) {
          if (uniqueDates.length < 2) {
            uniqueDates.push(dateKey);
          } else {
            break;
          }
        }

        filteredActivities.push(item);
      }

      console.log("Unique Dates:", uniqueDates);
      console.log("Filtered Activities:", filteredActivities);

      setActivities(filteredActivities);
    } catch (err) {
      console.error("Unexpected error:", err);
      setActivities([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (activities.length === 0) {
    return <p>No activity found</p>;
  }

  return (
    <div className="gac-wrapper">
      {activities.map((activity) => (
        <div className="gac-card" key={activity.id}>
          {/* ✅ action_by SABSE UPAR */}
          <div className="gac-action-top">
            <span className="gac-action-by">
              {activity.action_by} performed this action
            </span>
          </div>

          <div className="gac-top-row">
            <div className="gac-user-info">
              <div className="gac-avatar-wrap">
                <img
                  src={activity.avatar_url}
                  alt="avatar"
                  className="gac-avatar"
                />
              </div>

              <div>
                <div className="gac-name-row">
                  <span className="gac-username">{activity.user}</span>
                  <span className="gac-contributed"> contributed to </span>
                  <span className="gac-repo">{activity.repo}</span>
                </div>

                <div className="gac-time">
                  {new Date(activity.timestamp).toLocaleString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                    hour: "numeric",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                  })}
                </div>
              </div>
            </div>

            <button className="gac-dots">•••</button>
          </div>
          {/* <h3
  className={`gac-pr-title ${
    activity.pr_number ? "gac-pr-green" : ""
  }`}
>
  Pull Request{" "}
  <span className="gac-pr-number">#{activity.pr_number}</span>
</h3> */}
          {activity.pr_number && (
            <h3 className="gac-pr-title">
              Pull Request{" "}
              <span className="gac-pr-number">#{activity.pr_number}</span>
            </h3>
          )}
          <div className="gac-badge-row">
            <span
              className={`gac-status-badge ${
                activity.event_type?.toUpperCase().includes("MERGED")
                  ? "gac-badge-merged"
                  : activity.event_type?.toUpperCase().includes("PUSH")
                    ? "gac-badge-push"
                    : "gac-badge-default"
              }`}
            >
              {activity.event_type}
            </span>
          </div>

          <div className="gac-divider" />
        </div>
      ))}
    </div>
  );
}

export default GitActivityCard;
